var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Checkbox as MuiCheckbox, FormControl, FormControlLabel, FormHelperText, } from '@mui/material';
import classNames from 'classnames';
import { Controller } from 'react-hook-form';
export function Checkbox(_a) {
    var control = _a.control, name = _a.name, label = _a.label, rules = _a.rules, required = _a.required, className = _a.className, labelClassName = _a.labelClassName, after = _a.after, rest = __rest(_a, ["control", "name", "label", "rules", "required", "className", "labelClassName", "after"]);
    return (_jsx(Controller, { control: control, name: name, rules: rules, render: function (_a) {
            var _b = _a.field, onChange = _b.onChange, onBlur = _b.onBlur, value = _b.value, name = _b.name, ref = _b.ref, error = _a.fieldState.error;
            return (_jsxs(FormControl, __assign({ error: !!error, required: required, className: "".concat(className) }, rest, { children: [_jsxs("div", __assign({ className: "flex flex-row items-center" }, { children: [_jsx(FormControlLabel, { className: classNames('mr-0', labelClassName), control: _jsx(MuiCheckbox, { onChange: onChange, checked: !!value, name: name, inputRef: ref, onBlur: onBlur }), label: label }), after && (_jsxs(_Fragment, { children: ["\u00A0", after] }))] })), error && (_jsx(FormHelperText, __assign({ className: "contents" }, { children: error.message })))] })));
        } }));
}
export default Checkbox;
